



























































import Vue from 'vue';
import { PropType } from 'vue';
import { PropValidator } from 'vue/types/options';
export type InputMessage = string | string[];
export type InputValidationRule = (value: any) => string | boolean;

export type InputValidationRules = (InputValidationRule | string)[];
interface Options extends InstanceType<typeof Vue> {
  $refs: {
    files: HTMLInputElement;
  };
}
export default Vue.extend<Options>({ functional: false }).extend({
  name: 'VDragDropFileInput',

  props: {
    value: [Object, Array] as PropType<File | File[]>,
    multiple: Boolean,
    placeholder: {
      type: String,
      default: 'Drag & Drop files here'
    },
    placeholderDrag: {
      type: String,
      default: 'Drop your file here'
    },

    backgroundColor: {
      type: String,
      default: 'grey lighten-3'
    },

    errorMessages: {
      type: [String, Array],
      default: () => []
    } as PropValidator<InputMessage | null>
  },

  data() {
    return {
      lazyValue: this.value,
      dragging: false
    };
  },
  computed: {
    internalValue: {
      get(): File[] | File {
        return this.lazyValue;
      },
      set(val: File | File[]) {
        this.lazyValue = val;
        this.$emit('change', this.lazyValue);
      }
    },
    internalErrorMessages(): (InputValidationRule | string)[] {
      return this.genInternalMessages(this.errorMessages);
    }
  },

  methods: {
    onInputChange(e: MouseEvent) {
      const files = [...((e.target as HTMLInputElement).files || [])];

      this.$emit('change', this.multiple ? files : files[0]);

      this.$nextTick(() => {
        this.$refs.files.value = '';
      });
    },

    genInternalMessages(messages: InputMessage | null): InputValidationRules {
      if (!messages) return [];
      else if (Array.isArray(messages)) return messages;
      else return [messages];
    }
  }
});
